/** Referenced by auth forms via `aria-describedby` while they are busy. */
export const AUTH_FORM_LOADING_HINT_ID = "auth-form-loading";

/**
 * Shown under an auth form while its fields are disabled pending hydration,
 * so the greyed-out form doesn't read as broken.
 */
export function FormLoadingHint() {
  return (
    <p
      id={AUTH_FORM_LOADING_HINT_ID}
      role="status"
      className="text-center text-[12px] text-text-tertiary"
    >
      Loading…
    </p>
  );
}
